<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [autoClearSearch]="false" [(ngModel)]="top" placeholder="Seleccionar Top"
    (select)="changeTop($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>

</ngx-select>